export default __webpack_public_path__ + "static/media/edits-colored-icon.4194811f.svg";